import styled from "styled-components";
import Theme from "../../Styles/Themes";
import config from '../../Config/config.json';

const colors = {
    idle: '#C7C7C7',
    hover: '#A3A3A3',
    focus: '#006560',
    error: '#FF3939',
    hint: '#7A7A7A',
};

export const Container = styled.div`
    align-items: ${props => props.$aling ? props.$aling : 'center'};
    display: flex;
    flex-direction: column;
    gap: 4px;
    justify-content: center;
    width: ${props => props.$width ? props.$width : '100%'};
`;

export const Field = styled.div`
    align-items: center;
    border: 2px solid ${props => props.$error ? colors.error : props.$focused || props.$valid ? colors.focus : colors.idle};
    border-radius: 10px;
    display: flex;
    overflow: hidden;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
    width: 100%;
    box-shadow: ${props => props.$focused ? `0 0 0 3px ${props.$error ? 'rgba(255, 57, 57, 0.15)' : 'rgba(0, 101, 96, 0.15)'}` : 'none'};

    &:hover {
        border-color: ${props => props.$error ? colors.error : props.$focused || props.$valid ? colors.focus : colors.hover};
    }
`;

export const CountryPrefix = styled.span`
    align-items: center;
    align-self: stretch;
    background: #F2F2F2;
    border-right: 1px solid #E0E0E0;
    color: #333;
    display: flex;
    flex-shrink: 0;
    font-size: ${Theme[config.theme].font.labels['small'].size};
    font-weight: 500;
    padding: 0 12px;
    user-select: none;

    @media (min-width: 720px) {
        font-size: ${Theme[config.theme].font.labels[config.fontSize].size};
        padding: 0 16px;
    }
`;

export const TextInput = styled.input`
    background: transparent;
    border: none;
    color: #006560;
    flex: 1;
    font-size: ${Theme[config.theme].font.labels['small'].size};
    font-variant-numeric: tabular-nums;
    font-weight: 400;
    letter-spacing: 0.3px;
    line-height: ${Theme[config.theme].font.labels[config.fontSize].line_height};
    min-width: 0;
    outline: none;
    padding: 10px 8px 10px 12px;

    &::placeholder {
        color: #B5B5B5;
    }

    @media (min-width: 720px) {
        font-size: ${Theme[config.theme].font.labels[config.fontSize].size};
        padding: 17px 12px 19px 16px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        font-size: ${Theme[config.theme].font.labels['small'].size};
        padding: 10px;
    }
`;

export const StatusIcon = styled.span`
    align-items: center;
    color: ${colors.focus};
    display: flex;
    flex-shrink: 0;
    padding-right: 14px;

    svg {
        height: 20px;
        width: 20px;
    }
`;

export const HelperText = styled.span`
    color: ${props => props.$error ? colors.error : colors.hint};
    font-size: ${Theme[config.theme].font.paragraphs['small'].size};
    line-height: ${Theme[config.theme].font.paragraphs['small'].line_height};
    min-height: ${Theme[config.theme].font.paragraphs['small'].line_height};
    width: 100%;
`;

export const SuggestionButton = styled.button`
    background: none;
    border: none;
    color: #006560;
    cursor: pointer;
    font-size: ${Theme[config.theme].font.paragraphs['small'].size};
    font-weight: 600;
    line-height: inherit;
    padding: 0;
    text-decoration: underline;
    text-underline-offset: 2px;

    &:hover {
        color: #004A46;
    }
`;
